import { Button } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'
import { generatePath, useNavigate } from 'react-router-dom'

import { useWhiteLabelBgTextClassName } from '@/hooks/useWhiteLabelBgTextClassName.ts'
import { licenseSlice } from '@/store/licenseSlice'
import { getSpotsPageByBookingMode } from '@/utils/getSpotsPageByBookingMode'
import { TICKETS_PATH } from '../../app/router/paths'
import { Card } from '../../components/Card'
import { useAppDispatch, useAppSelector } from '../../hooks/store'
import { BookingAvailability } from '../../store/bookingAvailabilitySlice'
import { cartSlice } from '../../store/cartSlice'

interface Props {
  areSpotsAvailable: boolean
  areTicketsAvailable: boolean
}

export const ChooseProductDefault = (props: Props) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const license = useAppSelector(licenseSlice.selectors.license)
  const dispatch = useAppDispatch()

  const textClassName = useWhiteLabelBgTextClassName('hidden md:block')
  if (!license) return null
  const spotsPage = getSpotsPageByBookingMode(license?.bookingMode)

  return (
    <main className="container grow py-8">
      <div className="mb-20 flex flex-col items-center justify-center gap-x-8 gap-y-4 md:mt-20 md:flex-row">
        <Card
          action={
            <Button
              disabled={!props.areSpotsAvailable}
              fullWidth
              onClick={() => {
                dispatch(
                  cartSlice.actions.setBookingType(BookingAvailability.SPOTS)
                )
                navigate(generatePath(spotsPage, { license: license?.license }))
              }}
              type="button"
            >
              {t('chooseProduct.spot.book')}
            </Button>
          }
          isSoldOut={!props.areSpotsAvailable}
          list={[
            t('chooseProduct.spot.listItem00'),
            t('chooseProduct.spot.listItem01'),
          ]}
          title={t('chooseProduct.spot.title')}
        />

        <div className={textClassName}>{t('chooseProduct.or')}</div>

        <Card
          action={
            <Button
              color="primary"
              disabled={!props.areTicketsAvailable}
              fullWidth
              onClick={() => {
                navigate(
                  generatePath(TICKETS_PATH, { license: license?.license })
                )
                dispatch(
                  cartSlice.actions.setBookingType(BookingAvailability.TICKETS)
                )
              }}
              type="button"
              variant="outline"
            >
              {t('chooseProduct.ticket.book')}
            </Button>
          }
          isSoldOut={!props.areTicketsAvailable}
          list={[
            t('chooseProduct.ticket.listItem00'),
            t('chooseProduct.ticket.listItem01'),
          ]}
          title={t('chooseProduct.ticket.title')}
        />
      </div>
    </main>
  )
}
